import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/home/Navigation';
import HeroSection from '../components/home/HeroSection';
import ExecutionGapSection from '../components/home/ExecutionGapSection';
import ChallengesSection from '../components/home/ChallengesSection';
import PropositionSection from '../components/home/PropositionSection';
import HowWeWorkSection from '../components/home/HowWeWorkSection';
import EvidenceSection from '../components/home/EvidenceSection';
import ProofStripSection from '../components/home/ProofStripSection';
import SectorFocusSection from '../components/home/SectorFocusSection';
import WhyApigSection from '../components/home/WhyApigSection';
import LeadershipSection from '../components/home/LeadershipSection';
import ContactSection from '../components/home/ContactSection';
import Footer from '../components/home/Footer';
import TechBridgePopup from '../components/home/TechBridgePopup';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Helmet>
        <title>APIG | The Alliance for Predictive Intelligence & Growth</title>
        <meta name="description" content="APIG helps leadership teams make high-stakes growth decisions with greater clarity and confidence — from validated insight to strategic action to measurable growth. Three integrated capabilities: Predictive Intelligence, Strategic Positioning, and Growth Activation." />
        <link rel="canonical" href="https://predictiveintelligencegrowthalliance.com/" />
      </Helmet>
      <Navigation />
      <TechBridgePopup />
      <main>
        <HeroSection />
        <ExecutionGapSection />
        <ChallengesSection />
        <PropositionSection />
        <HowWeWorkSection />
        <EvidenceSection />
        <ProofStripSection />
        <SectorFocusSection />
        <WhyApigSection />
        <LeadershipSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
